module.exports = __webpack_public_path__ + "img/1.4485b5d3.png";